import Layout from '@/layouts/Layout';
import ReviewStep from './components/ReviewStep';
import type { JournalEntry } from '@domain/journal';

type Props = {
  entry: JournalEntry;
};

export default function Show({ entry }: Props) {
  return (
    <Layout user={{ name: 'Cliente' }}>
      <ReviewStep entry={entry} description="Questo è il riepilogo della pagina di diario." />
    </Layout>
  );
}
